import React from 'react';
import PropTypes from 'prop-types';
import CreditCard from './creditCard';
import GooglePay from './googlePay';
import ApplePay from './applePay';
import Bit from './bit';
import CashApp from './cashApp';
import Ideal from './ideal';
import Pledger from './pledger';
import Matbia from './matbia';
import Ojc from '../Gateways/Ojc';
import Aac from '../Gateways/Aac';
import DonorsFund from '../Gateways/DonorsFund';
import Chariot from '../Gateways/Chariot';
import PayPal from '../Gateways/PayPal';
import Asserbishvil from '../Gateways/Asserbishvil';
import Broom from '../Gateways/Broom';
import Belz from '../Gateways/Belz';
import CMZ from '../Gateways/CMZ';
import KolYom from '../Gateways/KolYom';
import MHTrust from '../Gateways/MHTrust';
import YadShlomo from '../Gateways/YadShlomo';
import ZoreyaTzedokos from '../Gateways/ZoreyaTzedokos';
import Authorize from '../Gateways/Authorize';

const PAYMENT_METHOD_ICONS = {
    applepay: ApplePay,
    bit: Bit,
    card: CreditCard,
    cashapp: CashApp,
    googlepay: GooglePay,
    ideal: Ideal,
    matbia: Matbia,
    pledger: Pledger,
    ojcfund: Ojc,
    aac: Aac,
    asserbishvil: Asserbishvil,
    broom: Broom,
    belz: Belz,
    cmz: CMZ,
    kolyom: KolYom,
    mhtrust: MHTrust,
    yadshlomo: YadShlomo,
    zoreyatzedokos: ZoreyaTzedokos,
    donorsfund: DonorsFund,
    chariot: Chariot,
    paypal: PayPal,
    authorize: Authorize,
};

function PaymentMethodIcon({ paymentMethod = '', ...restProps }) {
    const Icon = PAYMENT_METHOD_ICONS[paymentMethod];

    if (!Icon) {
        return null;
    }

    return <Icon {...restProps} />;
}

PaymentMethodIcon.propTypes = {
    paymentMethod: PropTypes.string,
};

export default PaymentMethodIcon;
